lmApp.service('DVRTasksResource', ['$resource', function ($resource) {
  return $resource('/discovery:80/sdp/v2/dvr-tasks',
    null,
    {
      get: {
        url: '/discovery:80/sdp/v2/dvr-tasks?$expand=subscriber,live(resources),program',
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      list: {
        url: '/discovery:80/sdp/v2/dvr-tasks',
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      remove: {
        url: '/discovery:80/sdp/v2/dvr-tasks/:id',
        method: 'DELETE',
        params: {
          id: '@id'
        },
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      count: {
        url: '/discovery:80/sdp/v2/dvr-tasks/$count',
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      getHLSStream: {
        url: '/discovery:80/sdp/v2/dvr-tasks/:id/url',
        method: 'GET',
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken'),
          'X-Instance-Check': ''
        },
        params: {
          id: '@id'
        }
      },
      getDashStream: {
        url: '/discovery:80/sdp/v2/dvr-tasks/:id/url?stream_format=dash',
        method: 'GET',
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken'),
          'X-Instance-Check': ''
        },
        params: {
          id: '@id'
        }
      }
    });
}]);
